import { gql } from 'graphql-tag';
import { projectBasicInfoFragment } from './projectBasicInfoFragment';

export const UPDATE_PROJECT_BASIC_INFO_MUTATION = gql`
  mutation UpdateProjectBasicInfo($projectInput: ProjectInput!) {
    updateProject2(projectInput: $projectInput) {
      ...ProjectBasicInfo
    }
  }
  ${projectBasicInfoFragment}
`;
